module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step2a_Image8i.40aa42c3.jpg";